import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "优惠券：", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("手机号")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("搜索用户")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确认发放 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "发放抽赏优惠券",
    width: "500px",
    "close-on-click-modal": false,
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: _ctx.onClose }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.submitting,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.coupon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.coupon.name) + " ", 1),
              _createVNode(_component_el_tag, {
                class: "ms-2",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.coupon.discount_text), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.formData,
              rules: _ctx.rules,
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "发放方式",
                  prop: "grantType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.formData.grantType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.grantType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "mobile" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "search" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.formData.grantType === 'mobile')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "手机号",
                      prop: "mobiles"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.mobiles,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.mobiles) = $event)),
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入用户手机号，每行一个"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formData.grantType === 'search')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "选择用户",
                      prop: "user_ids"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.user_ids,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.user_ids) = $event)),
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: "搜索用户手机号或昵称",
                          "remote-method": _ctx.searchUsers,
                          loading: _ctx.userSearchLoading,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: `${item.nickname} (${item.mobile})`,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method", "loading"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}